module.exports = __webpack_public_path__ + "img/partner_00_goodmills.4982e518.png";